module.exports = __webpack_public_path__ + "static/media/no-avatar.30cdb6f3.svg";